import fulfill from '../../fulfill';
import { SideEffectFunction } from '../../sideEffects';
import { ActionTypes, Capture, OperationResult } from './actions';
import { CORE_API_HOSTNAME } from '../../env';
import { GetOrder, getOrder } from '../orderDetails/actions';
import { OperationLineItem } from '../types';

interface RequestItem {
    line_id: number;
    amount: number;
}

interface RequestBody {
    success: true;
    items: RequestItem[];
    authorization_id?: string;
}

interface HttpError {
    error: {
        message: string;
        code: string;
        errors: any;
    };
}

const toRequestBodyItems = (items: OperationLineItem[]): RequestItem[] => {
    return items.map((operationLineItem) => ({
        line_id: operationLineItem.item.line_id || -1,
        amount: operationLineItem.amount,
    }));
};

const postOrderOperation: SideEffectFunction<Capture, OperationResult> = async (action) => {
    const requestBody: RequestBody = {
        success: true,
        items: toRequestBodyItems(action.payload.items),
    };

    if (action.payload.authorizationId) {
        requestBody.authorization_id = action.payload.authorizationId;
    }

    const result: OperationResult = await fulfill.post<RequestBody>({
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.payload.accountId}/shopping/orders/${action.payload.order.order_id}/captures`,
        accountId: action.payload.accountId,
        json: requestBody,
        handlers: {
            200: () => ({
                type: ActionTypes.SuccessResponse,
                payload: {},
                meta: {
                    cause: action,
                },
            }),
            400: (response: HttpError) => {
                return {
                    type: ActionTypes.ErrorResponse,
                    payload: {
                        code: response.error.code,
                        message: response.error.message,
                        errors: response.error.errors,
                    },
                    meta: {
                        cause: action,
                    },
                };
            },
        },
    });
    return result;
};

const refetchOrder: SideEffectFunction<OperationResult, GetOrder> = async (action) => {
    return getOrder(action.meta.cause.payload.accountId, action.meta.cause.payload.order.order_id || '');
};

const effects = {
    [ActionTypes.InvokeRequest]: postOrderOperation,
    [ActionTypes.SuccessResponse]: refetchOrder,
    [ActionTypes.ErrorResponse]: refetchOrder,
};

export default effects;
